/* Native details remains the no-JS fallback; animate both directions from the current height. */
(() => {
  if (window.zuofunDiscoveryMotion) return;
  window.zuofunDiscoveryMotion = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.zf-discovery details > summary');
    if (!summary || event.target.closest('a, button, input')) return;
    const details = summary.parentElement;
    const content = summary.nextElementSibling;
    if (!content || !details.animate) return;
    event.preventDefault();
    const previous = states.get(details);
    const opening = !(previous ? previous.opening : details.open);
    const startHeight = details.getBoundingClientRect().height;
    const startOpacity = getComputedStyle(content).opacity;
    if (previous) {
      previous.height.cancel();
      previous.fade.cancel();
    }
    if (reduced.matches) {
      states.delete(details);
      details.open = opening;
      details.style.removeProperty('overflow');
      delete details.dataset.motionOpen;
      return;
    }
    const wasOpen = details.open;
    details.open = true;
    const endHeight = opening ? details.getBoundingClientRect().height
      : summary.getBoundingClientRect().height + parseFloat(getComputedStyle(details).borderTopWidth || 0) + parseFloat(getComputedStyle(details).borderBottomWidth || 0);
    details.dataset.motionOpen = String(opening);
    details.style.overflow = 'hidden';
    const timing = { duration: opening ? 320 : 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };
    const height = details.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], timing);
    const fade = content.animate([{ opacity: wasOpen ? startOpacity : 0 }, { opacity: opening ? 1 : 0 }], timing);
    const state = { height, fade, opening };
    states.set(details, state);
    height.onfinish = () => {
      if (states.get(details) !== state) return;
      details.open = opening;
      details.style.removeProperty('overflow');
      delete details.dataset.motionOpen;
      states.delete(details);
    };
  });
})();
